<div class="row mt-5">
    <div class="col-12">
        <div class="card" #containerRef>
            <div class="card-header">
                <h4 class="card-title">Timeline</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="table-responsive">
                        <google-chart [type]="'Timeline'" [data]="dataTimeline" [options]="optionsTimeline"
                            [columns]="columnsTimeline" style="width: 100%; height: 65vh;" lang="es"></google-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>